export default __webpack_public_path__ + "static/media/718.9868541f.png";